import React from 'react'

import { NavigationCircle } from '../../../NavigationCircle'
import NavigationBarWrapper from './styles/NavigationBarWrapper'

interface Props {
  currentSlide: number
  slidesAmount: number
  goToSlide: (slide: number) => void
  duration: number
  isTransitioning: boolean
  paused?: boolean
}

export function Navigation({ currentSlide, slidesAmount, goToSlide, duration, isTransitioning, paused }: Props) {
  if (slidesAmount <= 1) {
    return null
  }

  return (
    <NavigationBarWrapper id="navigation-bar">
      {[...Array(slidesAmount).keys()].map((_, index) => (
        <NavigationCircle
          key={`slide-circle-${index}`}
          isActive={index === currentSlide}
          onClick={() => (!isTransitioning ? goToSlide(index) : null)}
          duration={duration}
          paused={paused}
        />
      ))}
    </NavigationBarWrapper>
  )
}
